import styled from 'styled-components';

export const TabsHeaderContainer = styled.div<{
  paddingTop?: string;
  paddingLeft?: string;
}>`
  display: flex;
  flex-direction: row;
  width: 100%;
  padding-top: ${(props) => props.paddingTop ?? '20px'};
  padding-left: ${(props) => props.paddingLeft ?? '20px'};
`;

export const TabsContainer = styled.div`
  display: flex;
  margin-top: 20px;
`;

export const TabsPanelsContainer = styled.div`
  width: 100%;
  display: flex;
  margin-bottom: 20px;
  padding: 20px 20px 0 20px;
`;

interface TabPanelProps {
  active: boolean;
}

export const TabPanel = styled.div<TabPanelProps>`
  width: 100%;
  display: ${(props) => (props.active ? 'block' : 'none')};
`;
